/*
 * @Description: 广告组预览
 * @Author: yanzhigen@batmobi.net
 * @Date: 2018-10-08 15:31:27
 * @LastEditors: yanzhigen@batmobi.net
 * @LastEditTime: 2018-11-08 15:30:06
 */
<template>
    <div class="campaign-preview">
        <div class="panel" v-for="(item, index) in campaignBatchList" :key="index">
            <span
                class="delete"
                @click="
                    campaignBatchList.splice(index, 1);
                    $emit('update:flag', true);
                "
            >
                <Icon type="close-round"></Icon>
            </span>
            <div class="row title">
                <div v-if="index != currentIndex || type != 'name'" class="item title showregular">
                    <span :title="item.name" class="showregular" style="display: inline-block; max-width: 8rem"
                        >广告组名称：{{ item.name }}</span
                    >
                    <span @click="showEdit(index, 'name')" class="icon-edit" style="position: relative; top: -2px">
                        <Icon type="edit"></Icon>
                    </span>
                </div>
                <div v-else class="item title edit">
                    <span>广告组名称：</span>
                    <Input element-id="name" v-model="name" :maxlength="200" class="input" size="small" />
                    <Button @click="currentIndex = -1" size="small" type="default">取消</Button>
                    <Button @click="saveEdit('name')" size="small" type="info">保存</Button>
                </div>
            </div>
            <div class="row">
                <div :title="item.targetCountries ? item.targetCountries : '不限'" class="item showregular">
                    国家：{{ item.targetCountries ? item.targetCountries : '不限' }}
                </div>
                <div :title="item.targetLanguages ? item.targetLanguages : '不限'" class="item showregular">
                    语言：{{ item.targetLanguages ? item.targetLanguages : '不限' }}
                </div>
            </div>
            <div class="row">
                <div v-if="index != currentIndex || type != 'bidPrice'" class="item showregular">
                    <div class="item">
                        <span>出价：{{ bidTypeList[item.bidType] }} {{ '$ ' + item.bidPrice }}</span>
                        <span @click="showEdit(index, 'bidPrice')" class="icon-edit">
                            <Icon type="edit"></Icon>
                        </span>
                    </div>
                </div>
                <div v-else class="item edit">
                    <span style="margin-right: 0.05rem">出价：{{ bidTypeList[item.bidType] }}</span>
                    <Input
                        element-id="bidPrice"
                        v-model.trim="bidPrice"
                        @on-keyup="(e) => mixinRegNum(e, 5)"
                        @on-change="(e) => mixinRegNum(e, 5)"
                        @on-input="(e) => mixinRegNum(e, 5)"
                        :maxlength="14"
                        class="input"
                        size="small"
                    />
                    <Button @click="currentIndex = -1" size="small" type="default">取消</Button>
                    <Button @click="saveEdit('bidPrice')" size="small" type="info">保存</Button>
                </div>
                <div v-if="index != currentIndex || type != 'dailyBudgetValue'" class="item showregular">
                    <div class="item">
                        <span
                            >预算：{{ dailyBudgetTypeList[item.dailyBudgetType] }}
                            {{
                                item.dailyBudgetValue
                                    ? item.dailyBudgetValue + ' ' + dailyBudgetUnit[item.dailyBudgetType]
                                    : '不限'
                            }}</span
                        >
                        <span @click="showEdit(index, 'dailyBudgetValue')" class="icon-edit">
                            <Icon type="edit"></Icon>
                        </span>
                    </div>
                </div>
                <div v-else class="item edit">
                    <span style="margin-right: 0.05rem">预算：{{ dailyBudgetTypeList[item.dailyBudgetType] }}</span>
                    <Input
                        element-id="dailyBudgetValue"
                        v-model="dailyBudgetValue"
                        @on-keyup="(e) => mixinRegNum(e, 0)"
                        :maxlength="8"
                        class="input"
                        size="small"
                    />
                    <Button @click="currentIndex = -1" size="small" type="default">取消</Button>
                    <Button @click="saveEdit('dailyBudgetValue')" size="small" type="info">保存</Button>
                </div>
            </div>
        </div>
        <!-- 保存 -->
        <div class="panel panel-btn">
            <Button type="default" size="large" @click="onClickLastStep" style="margin-right: 0.3rem">上一步</Button>
            <Button type="primary" size="large" @click="$emit('next-step', 2)" style="margin-right: 0.3rem"
                >新建广告</Button
            >
            <!-- <Button type="primary" size="large" @click="$emit('submit')">保存并关闭</Button> -->
        </div>
    </div>
</template>
<script>
import mixins from '@/mixins';
export default {
    name: 'CampaignPreview',
    mixins: [mixins],
    props: {
        flag: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            urlQuery: this.mixinGetQueryObject(),
            bidPrice: '',
            dailyBudgetValue: '',
            name: '',
            currentIndex: -1,
            type: 'bidPrice',
            bidTypeList: {
                1: 'CPM',
                2: 'CPA',
                3: 'CPC',
            },
            dailyBudgetTypeList: {
                dailyBudget: '花费',
                dailyImp: '展示',
                dailyClick: '点击',
            },
            dailyBudgetUnit: {
                dailyBudget: '美元',
                dailyImp: '千次',
                dailyClick: '次',
            },
        };
    },
    computed: {
        status() {
            return this.$store.state.newPromotion.status;
        },
        userData() {
            return this.$store.state.userData;
        },
        campaignParams() {
            return this.$store.state.newPromotion.campaignParams;
        },
        campaignBatchList() {
            return this.$store.state.newPromotion.campaignBatchList;
        },
        campaignError() {
            return this.$store.getters.campaignError;
        },
    },
    methods: {
        /**
         * @desc 显示编辑
         */
        showEdit(index, type) {
            this.currentIndex = index;
            this.type = type;
            this[type] = this.campaignBatchList[index][type];
            if (type == 'dailyBudgetValue' && this[type] == 0) this[type] = '';
        },
        /**
         * @desc
         */
        saveEdit(type) {
            if (type == 'name' && !this[type]) {
                this.$Message.error({ content: '请输入名称' });
                return;
            } else if (type == 'bidPrice') {
                let content = '';
                if (this.userData.source == 'batmobi') {
                    if (!parseFloat(this.bidPrice)) content = '请输入大于0的出价';
                } else if (this.campaignParams.bidType == 1 && !(parseFloat(this.bidPrice) >= 0.01))
                    content = '请输入不少于0.01的出价';
                else if (this.campaignParams.bidType == 2 && !(parseFloat(this.bidPrice) >= 0.03))
                    content = '请输入不少于0.03的出价';
                else if (this.campaignParams.bidType == 3 && !(parseFloat(this.bidPrice) >= 0.0006))
                    content = '请输入不少于0.0006的出价';
                if (content) {
                    this.$Message.error({ content });
                    return;
                }
            } else if (type == 'dailyBudgetValue' && this[type] == 0 && (this[type] + '').length) {
                this.$Message.error({ content: '预算不能为0' });
                return;
            }
            this.campaignBatchList[this.currentIndex][type] = document.querySelector(`#${type}`).value;
            this.$emit('update:flag', true);
            this.currentIndex = -1;
        },
        /**
         * @desc
         */
        onClickLastStep() {
            if (this.flag) {
                this.$Modal.confirm({
                    content: '修改变量将重置广告组预览的设置，是否继续操作？',
                    onOk: () => {
                        this.$emit('last-step');
                        this.$emit('update:flag', false);
                    },
                });
            } else this.$emit('last-step');
        },
    },
};
</script>
<style lang="scss">
.campaign-preview {
    .panel {
        position: relative;
        .delete {
            cursor: pointer;
            position: absolute;
            right: 0.2rem;
            top: 0.2rem;
            font-size: 0.14rem;
            color: #666666;
        }
    }
    .row {
        margin-top: 0.2rem;
        display: flex;
        align-items: center;
        &.title {
            margin-top: 0;
        }
        .item {
            position: relative;
            font-size: 0.14rem;
            flex: 0 0 4rem;
            margin-right: 0.3rem;
            max-width: 4rem;
            padding-right: 0.3rem;
            .icon-edit {
                margin-left: 0.1rem;
                cursor: pointer;
            }
            .ivu-input {
                height: 0.28rem;
                font-size: 0.14rem;
            }
            &.title {
                font-size: 0.16rem;
                font-weight: bold;
                max-width: 8.3rem;
                flex: 0 0 8.3rem;
            }
            &.edit {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0;
                & > * {
                    flex: 0 0 auto;
                }
                & > button {
                    margin-left: 0.1rem;
                }
                .input {
                    flex: 1 1 auto;
                    font-weight: normal;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/NewPromotion/CampaignPreview.vue